export default "<ion-toggle (click)=\"changeTheme()\" [checked]=\"currentTheme === 'dark'\"></ion-toggle>";